import { z } from "zod"

export const personAttachmentsSchema = z.object({
  socialContract: z.any().optional(),
  addressProofPJ: z.any().optional(),
  bankAccountProofPJ: z.any().optional(),
  addressProofPF: z.any().optional(),
  cnpjCard: z.any().optional(),
  photoDocument: z.any().optional(),
  vaccinationCard: z.any().optional(),
  drtDocument: z.any().optional(),
})

export type PersonAttachmentsSchema = z.infer<typeof personAttachmentsSchema>
